import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import * as yup from 'yup';
import { useFormik } from 'formik';
import * as departApi from '../../lib/api/department';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import DeptForm from '../../components/deptmng/DeptForm';
import { treeDeparts } from '../../modules/deptModule/departs';
import {
  setDepart,
  unloadDepart,
  viewDepart,
} from '../../modules/deptModule/depart';
import DetailTemplate from '../../components/common/template/DetailTemplate';
import DeptEmpListContainer from './DeptEmpListContainer';
import _ from 'lodash';

const DepartEditContainer = () => {
  const { id } = useParams();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [titleData, setTitleData] = useState(null);
  const [checkedRoles, setCheckedRoles] = useState([]);

  const onChangeChecked = (id) => {
    setCheckedRoles((checked) =>
      checked.includes(id)
        ? checkedRoles.filter((f) => f !== id)
        : [...checkedRoles, id],
    );
  };

  const { depart, error, loading } = useSelector(
    ({ departModule, loading }) => ({
      depart: departModule.depart.depart,
      error: departModule.depart.error,
      loading: loading['depart/VIEW_DEPART'],
    }),
  );

  useEffect(() => {
    if (id !== 'root') {
      dispatch(viewDepart(id));

      //언마운트될때 리덕스에서 파트너 데이터 초기화
      return () => {
        dispatch(unloadDepart());
      };
    }
  }, [id]);

  useEffect(() => {
    if (depart) {
      if (id === 'root') {
        setTitleData(null);
      } else {
        let title = {
          name: depart.dptNm,
        };
        setTitleData(title);
        setCheckedObject();
        //setCheckedRoles(depart?.roleList);
      }
    }
  }, [depart, id]);

  const setCheckedObject = () => {
    if (!_.isEmpty(depart?.roleList)) {
      const roles = _.keys(depart?.roleList);
      setCheckedRoles(roles);
    }
  };

  const getCheckedObject = () => {
    let obj = {};
    if (checkedRoles.length > 0) {
      _.forEach(checkedRoles, (role) => {
        obj[role] = 'Y';
      });
    }
    return obj;
  };

  const handleGoBack = () => {
    navigate(`/deptmng/${id}`);
  };

  const initialValues = {
    dptNm: depart && depart.dptNm !== null ? depart.dptNm : '',
    dptDesc: depart && depart.dptDesc !== null ? depart.dptDesc : '',
    leaderUuid: depart && depart.leaderUuid !== null ? depart.leaderUuid : '',
    emlAddr: depart && depart.emlAddr !== null ? depart.emlAddr : '',
    ectVal1: depart && depart.ectVal1 !== null ? depart.ectVal1 : '',
    ectVal2: depart && depart.ectVal2 !== null ? depart.ectVal2 : '',
    ectVal3: depart && depart.ectVal3 !== null ? depart.ectVal3 : '',
    statMerge: depart && depart.statMerge !== null ? depart.statMerge : '',
    useYn:
      depart && depart.useYn !== null && depart.useYn === 'Y' ? true : false,
  };

  const validationSchema = yup.object({
    dptNm: yup.string('').required('부서명을 입력하세요'),
    emlAddr: yup.string('').email('이메일 형식이 아닙니다').nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      let dataToSubmit = {
        dptUuid: depart.dptUuid,
        dptNm: values.dptNm,
        dptDesc: values.dptDesc,
        leaderUuid: values.leaderUuid,
        emlAddr: values.emlAddr,
        roleList: getCheckedObject(),
        ectVal1: values.ectVal1,
        ectVal2: values.ectVal2,
        ectVal3: values.ectVal3,
        statMerge: values.statMerge,
        useYn: values.useYn ? 'Y' : 'N',
      };

      //console.log(JSON.stringify(dataToSubmit), 'dataToSubmit');

      try {
        const response = await departApi.editDepart(id, dataToSubmit);
        //console.log(response.data,"data");
        if (response.data.result === 'success') {
          dispatch(setDepart(response.data.info));
          dispatch(treeDeparts());
          navigate(`/deptmng/${id}`);
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }

      formik.resetForm();
      setSubmitting(false);
    },
  });

  return (
    <>
      <TitleBox
        handleGoBack={handleGoBack}
        menuName="인사관리/부서관리/부서 정보 수정"
        menuLink="/deptmng"
        icon="depart"
        titleData={titleData}
      />

      <DetailTemplate title="기본 정보">
        <DeptForm
          formik={formik}
          checkedRoles={checkedRoles}
          onChangeChecked={onChangeChecked}
        />
      </DetailTemplate>
      <DetailTemplate title="부서 사원리스트">
        <DeptEmpListContainer depart={depart} />
      </DetailTemplate>
    </>
  );
};

export default DepartEditContainer;
